import { Mutex } from 'async-mutex';

export const casdoorMutex = new Mutex();
